// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-contact-js": () => import("/Users/peter/Sites/Gatsby/peteromalley.co.uk/src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-experience-js": () => import("/Users/peter/Sites/Gatsby/peteromalley.co.uk/src/pages/experience.js" /* webpackChunkName: "component---src-pages-experience-js" */),
  "component---src-pages-index-js": () => import("/Users/peter/Sites/Gatsby/peteromalley.co.uk/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

